

export const PageComponent : Map<string,any> = new Map();



// WEBPACK FOOTER //
// ./src/modules/RouterPage/AppPage.ts